// 顶部菜单配置
export const topNavConfig = {
  teacher: [
    {
      id: 10001,
      customName: '教学中心',
      key: 'teachCenter',
      backgroundUrl: 'https://cdnws.51tyty.com/lstyty/file/2023/09/01/a97b4eb92503c187070dcfe3c24cfc1b.png',
      hasHide: 'false',
      logoUrl: 'https://res.iiiview.net/tytydown/appui3/1/default/ls_main_icon_jxzx.png',
      subassemblyTitle: [
        {
          title: '教学中心',
        }
      ]
    },
    {
      id: 10002,
      customName: '管理中心',
      key: 'manageCenter',
      backgroundUrl: 'https://cdnws.51tyty.com/lstyty/file/2023/09/01/8752b0c45c36b1c762b255ef450eb2f1.png',
      hasHide: 'false',
      logoUrl: 'https://res.iiiview.net/tytydown/appui3/1/default/ls_main_icon_jwzx.png',
      subassemblyTitle: [
        {
          title: '管理中心',
        }
      ]
    },
    {
      id: 10003,
      customName: '教材管理',
      key: 'materialManager',
      backgroundUrl: 'https://cdnws.51tyty.com/lstyty/file/2023/09/01/7e246578a251c4b8fa02d8c425391233.png',
      hasHide: 'false',
      logoUrl: 'https://res.iiiview.net/tytydown/appui3/1/default/ls_main_icon_jcgl.png',
      subassemblyTitle: [
        {
          title: '教材管理',
        }
      ]
    },
    {
      id: 10004,
      customName: '拓展学习',
      key: 'expandLearn',
      backgroundUrl: 'https://cdnws.51tyty.com/lstyty/file/2023/09/01/7a77b187fe59dd33f4fc6b2fc1866b6f.png',
      hasHide: 'false',
      logoUrl: 'https://res.iiiview.net/tytydown/appui3/1/default/ls_main_icon_tzxx.png',
      subassemblyTitle: [
        {
          title: '拓展学习',
        }
      ]
    },
    {
      id: 10005,
      customName: '拓展教材',
      key: 'expandMaterial',
      backgroundUrl: 'https://cdnws.51tyty.com/lstyty/file/2023/09/01/f2e3ada942f6b0f816dcae42b3d5a998.png',
      hasHide: 'false',
      logoUrl: 'https://res.iiiview.net/tytydown/appui3/1/default/ls_main_icon_tzjc.png',
      subassemblyTitle: [
        {
          title: '拓展教材',
        }
      ]
    }
  ],
  admin: [
    {
      id: 10001,
      customName: '教务中心',
      key: 'eduAffairsCenter',
      backgroundUrl: 'https://cdnws.51tyty.com/lstyty/file/2023/09/01/8752b0c45c36b1c762b255ef450eb2f1.png',
      hasHide: 'false',
      logoUrl: 'https://res.iiiview.net/tytydown/appui3/1/default/ls_main_icon_jwzx.png',
      subassemblyTitle: [
        {
          title: '教务中心',
        }
      ]
    },
    {
      id: 10002,
      customName: '教学中心',
      key: 'teachCenter',
      backgroundUrl: 'https://cdnws.51tyty.com/lstyty/file/2023/09/01/a97b4eb92503c187070dcfe3c24cfc1b.png',
      hasHide: 'false',
      logoUrl: 'https://res.iiiview.net/tytydown/appui3/1/default/ls_main_icon_jxzx.png',
      subassemblyTitle: [
        {
          title: '教学中心',
        }
      ]
    },
    {
      id: 10003,
      customName: '教材管理',
      key: 'materialManager',
      backgroundUrl: 'https://cdnws.51tyty.com/lstyty/file/2023/09/01/7e246578a251c4b8fa02d8c425391233.png',
      hasHide: 'false',
      logoUrl: 'https://res.iiiview.net/tytydown/appui3/1/default/ls_main_icon_jcgl.png',
      subassemblyTitle: [
        {
          title: '教材管理',
        }
      ]
    },
    {
      id: 10004,
      customName: '拓展学习',
      key: 'expandLearn',
      backgroundUrl: 'https://cdnws.51tyty.com/lstyty/file/2023/09/01/7a77b187fe59dd33f4fc6b2fc1866b6f.png',
      hasHide: 'false',
      logoUrl: 'https://res.iiiview.net/tytydown/appui3/1/default/ls_main_icon_tzxx.png',
      subassemblyTitle: [
        {
          title: '拓展学习',
        }
      ]
    },
    {
      id: 10005,
      customName: '拓展教材',
      key: 'expandMaterial',
      backgroundUrl: 'https://cdnws.51tyty.com/lstyty/file/2023/09/01/f2e3ada942f6b0f816dcae42b3d5a998.png',
      hasHide: 'false',
      logoUrl: 'https://res.iiiview.net/tytydown/appui3/1/default/ls_main_icon_tzjc.png',
      subassemblyTitle: [
        {
          title: '拓展教材',
        }
      ]
    }
  ]
}

// 侧边菜单配置
export const leftNavConfig = [
  {
    id: '20000',
    title: '切换竖版',
    icon: 'https://cdnws.51tyty.com/lstyty/file/2023/09/04/fea71d623b6d4d7d7d225ab1d2ea7bbd.png',
    role: ['admin']
  },
  {
    id: '20001',
    title: '学校动态',
    icon: 'https://cdnws.51tyty.com/lstyty/file/2023/08/22/a1175961415f2822bb53f0defb4818c3.png',
    role: ['student', 'teacher', 'admin']
  },
  {
    id: '20002',
    title: '设置',
    icon: 'https://cdnws.51tyty.com/lstyty/file/2023/08/22/2bf00b87fcdbf9720da2ca1cd81c304a.png',
    role: ['student']
  },
  {
    id: '20003',
    title: '消息',
    icon: 'https://cdnws.51tyty.com/lstyty/file/2023/08/22/250c47e0537713b39579becdb08485dd.png',
    role: ['student']
  },
]

// 老师、管理员左侧菜单
export const leftNavConfigByManage = [
  {
    id: '20005',
    title: '分销商城',
    icon: 'https://cdnws.51tyty.com/lstyty/file/2023/10/10/3d9291abdc99136ef695f5a2886ca2f8.png',
    role: ['admin']
  },
  {
    id: '20006',
    title: '体验角色',
    icon: 'https://cdnws.51tyty.com/lstyty/file/2023/10/10/2f35ca003fa32dd07d4ffd2f6088d199.png',
    role: ['admin']
  },
  {
    id: '20000',
    title: '切换竖版',
    icon: 'https://cdnws.51tyty.com/lstyty/file/2023/09/04/fea71d623b6d4d7d7d225ab1d2ea7bbd.png',
    role: ['admin']
  },
  {
    id: '20001',
    title: '动态',
    icon: 'https://cdnws.51tyty.com/lstyty/file/2023/08/22/a1175961415f2822bb53f0defb4818c3.png',
    role: ['student', 'teacher', 'admin']
  },
  {
    id: '20003',
    title: '消息',
    icon: 'https://cdnws.51tyty.com/lstyty/file/2023/08/22/250c47e0537713b39579becdb08485dd.png',
    role: ['student']
  },
  {
    id: '20002',
    title: '设置',
    icon: 'https://cdnws.51tyty.com/lstyty/file/2023/08/22/2bf00b87fcdbf9720da2ca1cd81c304a.png',
    role: ['student']
  },
]
